import { render, staticRenderFns } from "./SGObjectStorageSummary.vue?vue&type=template&id=722b6ff5"
import script from "./SGObjectStorageSummary.vue?vue&type=script&lang=js"
export * from "./SGObjectStorageSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports